var map = {
	"./img1.jpg": 9950,
	"./img2.jpg": 6798,
	"./img3.jpg": 8487,
	"./img4.jpg": 150,
	"./img5.jpg": 4642,
	"./img7.jpg": 1883,
	"assets/gallery/img1.jpg": 9950,
	"assets/gallery/img2.jpg": 6798,
	"assets/gallery/img3.jpg": 8487,
	"assets/gallery/img4.jpg": 150,
	"assets/gallery/img5.jpg": 4642,
	"assets/gallery/img7.jpg": 1883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8245;